module.exports = "import React from 'react';\nimport { Alert } from 'reactstrap';\n\nclass AlertExample extends React.Component {\n  constructor(props) {\n    super(props);\n\n    this.state = {\n      visible: true\n    };\n\n    this.onDismiss = this.onDismiss.bind(this);\n  }\n\n  onDismiss() {\n    this.setState({ visible: false });\n  }\n\n  render() {\n    return (\n      <Alert color=\"info\" isOpen={this.state.visible} toggle={this.onDismiss}>\n        I am an alert and I can be dismissed!\n      </Alert>\n    );\n  }\n}\n\nexport default AlertExample;\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./docs/lib/examples/AlertDismiss.js
// module id = 324
// module chunks = 0